"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOdd = (input) => input % 2 === 1;
exports.default = exports.isOdd;
//# sourceMappingURL=is_odd.js.map